function _validateMultiPositionConfig(multiPositionConfig: MultiPositionConfig) {
	if (typeof multiPositionConfig.name !== 'string') {
		throw new Error('\'name\' is required and should be a string in multiPosition config');
	}

	if (!Array.isArray(multiPositionConfig.slots)) {
		throw new Error('\'slots\' is required and should be an array in multiPosition config');
	}
}

export default class MultiPosition {
	name: string;
	slots: Array<string>;
	node: HTMLElement;
	slotNodes: Array<HTMLElement>;

	constructor(cfg : MultiPositionConfig) {
		_validateMultiPositionConfig(cfg);

		this.name = cfg.name;
		this.slots = cfg.slots;
		this.node = null;
		this.slotNodes = [];
	}

	setNode(node: HTMLElement) {
		this.node = node;
		this.node.classList.add('advert-multi-position');

		this.slots.forEach((slotName) => {
			const slotNode = document.createElement('div');

			slotNode.id = `advert-multi-position-${this.name}-${slotName}`;

			this.slotNodes.push(slotNode);

			this.node.appendChild(slotNode);
		});
	}
}
